import { createContext } from 'react';
import appealInitialValues from 'src/data/formDataInitialValues/appeal';
import useForm from 'src/services/useForm';

const FormContext = createContext();

export const AppealFormProvider = ({ children }) => {
  const value = useForm({
    apiPath: '/appeal',
    createFormData: (data) => {
      const formData = new FormData();

      for (const key in data) {
        if (key === 'scheduleB') continue;
        formData.append(key, JSON.stringify(data?.[key]));
      }

      (data.scheduleB ?? []).forEach((file) => formData.append('scheduleB', file));

      return formData;
    },
    // Personal Property appeals are handled by the Assessor's Office; keep these in sync with
    // the contacts in server/appeal/appeal.js.
    contacts: [
      { name: 'Janalee Anderson', email: 'JanaleeA@utahcounty.gov', phone: '(801) 851-8296' },
      { name: 'Diane Pederson', email: 'DianeP@utahcounty.gov', phone: '(801) 851-8293' },
    ],
    initialValues: appealInitialValues,
    pageTitle: 'Property Appeal Form ',
  });

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export default FormContext;
